import { Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { ReactNode, useState } from 'react';
import { YearMonthPopoverContent } from '@/domain/controlling/components/YearMonthPicker/YearMonthPopoverContent';

export function YearMonthPicker({
  selectedDate = new Date(),
  children,
  buildUrl,
}: {
  selectedDate?: Date;
  children: ReactNode;
  buildUrl: (selectedDate: Date) => string;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent className="bg-white w-fit p-4" sideOffset={4}>
        <YearMonthPopoverContent
          buildUrl={buildUrl}
          selectedDate={selectedDate}
          setIsOpen={setIsOpen}
        />
      </PopoverContent>
    </Popover>
  );
}
